import { $, $$, closest } from 'utils/dom';

const footerIcons = $$('.footer__icon');

if (footerIcons.length) {
  footerIcons.forEach(footerIcon => {
    const footerIconButton = $('.footer__icon-button', footerIcon);
    const footerIconList = $('.footer__icon-list', footerIcon);

    if (footerIcon) {
      footerIcon.addEventListener('click', () => {
        const isActive = footerIconButton.classList.contains('is-active');
        footerIcons.forEach(item => {
          const footerIconButton = $('.footer__icon-button', item);
          const footerIconList = $('.footer__icon-list', item);

          footerIconButton.classList.remove('is-active');
          footerIconList.classList.remove('is-active');
        });

        if (isActive) return;
        footerIconButton.classList.add('is-active');
        footerIconList.classList.add('is-active');
      });
    }
  });

  const body = $('body');
  body.addEventListener('click', event => {
    const clickTarget = event.target;
    const isInsideFooterIcon = closest(clickTarget, '.footer__icon');
    if (!isInsideFooterIcon) {
      footerIcons.forEach(item => {
        const footerIconButton = $('.footer__icon-button', item);
        const footerIconList = $('.footer__icon-list', item);

        footerIconButton.classList.remove('is-active');
        footerIconList.classList.remove('is-active');
      });
    }
  });
}
